import SegmentedControl from './SegmentedControl.jsx';

/**
 * @param {{
 *   value: string | boolean;
 *   options: Array<{ value: string | boolean; label: string; disabled?: boolean }>;
 *   onChange: (value: string | boolean) => void;
 *   ariaLabel: string;
 *   disabled?: boolean;
 *   className?: string;
 *   role?: 'group' | 'tablist';
 *   optionRole?: 'button' | 'tab';
 * }} props
 */
function FloorPlanSegmentedToggle(props) {
  return <SegmentedControl {...props} />;
}

export default FloorPlanSegmentedToggle;
